import { IUsuarioxVideo } from "@/entities";

export class UsuarioXVideo implements IUsuarioxVideo {
  fkVideo: number;
  aceptaDatos: boolean;
  aceptaNovedad: boolean;
  observaciones?: string;
  timezone: string;

  constructor() {
    this.fkVideo = 0;
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.aceptaDatos = false;
    this.aceptaNovedad = false;
    this.observaciones = "";
  }
}
